import { gameScheduleSkeletonStyles as styles } from "./gameScheduleSkeletonStyles";
const GameScheduleSkeletons = ({ count = 3 }) => {
  return (
    <div className={styles.outerContainer}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.skeleton} />
      ))}
    </div>
  );
};

export default GameScheduleSkeletons;
